<template>
<div v-loading="loading">
  <div v-if="isEmpty(rootCauseDataList)" style="border: 1px solid #e9ebee; padding: 15px;">
    <span>
      장애 근원지 분석 결과 없음
    </span>
  </div>
  <el-row v-else style="border: 1px solid #e9ebee; padding: 15px;" type="flex" justify="space-between">
    <div class="vertical-center-box mr-r15">
      <span>이벤트 발생 패턴 학습 결과, <span style="color: #1c768d;">{{ rcaEventInfo }}</span>로 인한 장애 발생이라고 판단</span>
    </div>
    <div class="vertical-center-box">
      <el-button @click="openRcaEventPopup">RC 이벤트 분석</el-button>
    </div>
  </el-row>
  <div v-if="!isEmpty(rootCauseDataList)" class="box-component-item mr-t20" style="border: none;">
    <div class="smart-timeline">
      <li v-for="(item, index) in rootCauseDataList" :key="index" :class="index === 0 ? 'rca' : (index === rootCauseDataList.length - 1 ? 'target' : 'normal')">
        <div class="status" :style="getStatusStyle(item, index)"></div>
        <div class="message">
          <span v-if="index === 0" class="text-red">[RC]</span>
          <span class="link c-pointer" @click="clickObjName(item)">{{ item.objName }} ({{ item.ipaddress }})</span>
          <div>{{ item.rsctypeName }}>{{ item.rscName }}>{{ item.rscKeyName }}</div>
          <div>{{ item.eventMessage }}</div>
        </div>
      </li>
    </div>
  </div>
  <w-root-cause-event-analysis-popup ref="rootCauseEventAnalysisPopup" :rca-info="rcaInfoParam" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { routePathByObjId } from '@/utils/router';
import { isEmpty } from 'lodash';
import SmartAnalysisAPI from '@/api/common/smart-analysis';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import MsgUtil from '@/utils/message';
import { convertHex2Rgba } from '@/utils/basic';
import { EMPTY_TEXT } from '@/utils/string';
import WRootCauseEventAnalysisPopup from './popup/RootCauseEventAnalysisPopup';

/**
 * 장애근원지 분석 화면
 */
export default {
  name: 'WRootCauseAnalysisView',
  components: {
    WRootCauseEventAnalysisPopup,
  },
  props: {
    eventHistData: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      rootCauseDataList: [],
      rcaEventInfo: '',
      rcaInfoParam: null,
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    eventHistData: {
      handler(value) {
        if (isEmpty(value)) {
          this.reset();
        } else {
          this.loadData();
        }
      },
    },
  },
  methods: {
    isEmpty,
    convertHex2Rgba,
    /**
     * 이벤트에 대한 장애 근원지 분석 정보를 로드한다.
     * @author Ju
     */
    loadData() {
      const hashkeyIdString = this.eventHistData.hashkeyIdString;
      // 이벤트에 대한 장애 근원지 분석 정보를 로드한다.
      this.loading = true;
      SmartAnalysisAPI.getRootCauseAnalysisData({
        hashkeyIdString,
      })
        .then((response) => {
          if (response.data.success) {
            this.rootCauseDataList = response.data.data;
            if (!isEmpty(this.rootCauseDataList) && !isEmpty(this.rootCauseDataList[0])) {
              const rcaInfo = this.rootCauseDataList[0];
              this.rcaEventInfo = `${rcaInfo.objName} (${rcaInfo.ipaddress || EMPTY_TEXT}) [${rcaInfo.rsctypeName}>${rcaInfo.rscName}>${rcaInfo.rscKeyName}]`;
            }
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '장애근원지 분석 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '장애근원지 분석 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      // view 초기화
    },
    /**
     * 클릭한 obj의 성능/운영 분석화면으로 이동한다.
     * @author yelim
     */
    clickObjName(item) {
      let objId;
      if (item.managetypeId === 'E2E') {
        objId = item.rscKey.split('.')[1];
      } else {
        objId = item.objId;
      }
      routePathByObjId(this, objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds);
    },
    /**
     * 장애 근원 이벤트 분석 팝업 open
     * @author jeee12
     */
    openRcaEventPopup() {
      this.rcaInfoParam = this.rootCauseDataList[0];
      this.$refs.rootCauseEventAnalysisPopup.open();
    },
    getStatusStyle(item, index) {
      const style = {};
      if (index === this.rootCauseDataList.length - 1) {
        style.borderColor = item.eventlevelColorBg;
      } else {
        style.backgroundColor = item.eventlevelColorBg;
        if (index === 0) {
          style.boxShadow = `0 0 0 5px ${convertHex2Rgba(item.eventlevelColorBg, 25)}`;
        }
      }
      return style;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/EventSmartAnalyzerPopup/RootCauseAnalysisView.vue